import { render, staticRenderFns } from "./basket-form-postcards.vue?vue&type=template&id=2c7fdb68"
import script from "./basket-form-postcards.vue?vue&type=script&lang=js"
export * from "./basket-form-postcards.vue?vue&type=script&lang=js"
import style0 from "./basket-form-postcards.vue?vue&type=style&index=0&id=2c7fdb68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VImg,VTextarea})
